import React from 'react';
import { AddToCartReferType } from '@/constants/track';

import { getDeliveryDate } from '@/utils/common/porder';
import type { FeatureProductProperties } from './type';
import { BaseProductType } from '@/types/product';
import { CmsSsrComponentProps } from '@/types/cms';
import SkuVerticalProductCard from '@/components/common/ProductCard/sku-product/vertical';

interface ProductSingleProps {
  data: Partial<BaseProductType>;
  properties?: FeatureProductProperties;
  eventKey: string;
  position: number;
  trackingContext?: CmsSsrComponentProps['trackingContext'];
  isPreview?: boolean;
}

const ProductSingle: React.FC<ProductSingleProps> = ({ data, eventKey, position, trackingContext, isPreview }) => {
  return (
    <div className="px-10 pb-10 pt-4">
      <SkuVerticalProductCard
        labelOffType="large"
        priceSize="large"
        imageSize={375}
        mainContentClassName="px-4 pt-2 pb-5"
        brandImg={{
          containerClassName: 'right-4 bottom-4',
          className: 'w-12 h-12'
        }}
        addCartBtnTextCls="enki-body-base-medium"
        favoriteClassName="w-12 h-12 border border-solid border-surface-100-hairline bg-surface-100-bg rounded-full flex items-center justify-center cursor-pointer"
        purchaseClassName="enki-body-base-medium"
        addCartParams={{
          referType: AddToCartReferType.normal,
          deliveryDate: getDeliveryDate(),
          renderCartCountText: true
        }}
        // priceContainer="scale-[1.37] origin-top-left mt-[10px] mb-[16px]"
        positionInfoT2={{
          modSecPos: {
            mod_nm: eventKey,
            mod_pos: position
          },
          prodPos: 0,
          context: {
            tag_key: data?.entrance_tag?.tag_key,
            tag_name: data?.entrance_tag?.tag_name,
            ...trackingContext
          }
        }}
        data={data}
        showAddBtn={!isPreview}
      />
    </div>
  );
};

export default ProductSingle;
